import { Alert, Modal, OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import { PencilFill } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { useOrdenation } from '../../../hooks/useOrdenation'
import { formatPrice } from '../../../utils/formatPrice'
import { CustomButton } from '../../CustomButton'

export function ModalConsultarComposicao({ isOpen, onClose, data }) {
  const { filteredItems, Th, Paginate } = useOrdenation(data?.products, 'sku')

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header closeButton>
        <Modal.Title>Consultar Composição</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {filteredItems.length > 0 && (
          <>
            <Table
              responsive
              hover
              bordered
              striped
            >
              <thead>
                <>
                  <tr>
                    <th colSpan={localStorage.admin === 'SIM' ? 7 : 6}>
                      <Alert variant="info">
                        Para formar um kit, cada produto deve possuir uma
                        quantidade mínima em estoque.
                      </Alert>

                      <p>Kits possíveis: {data?.total}</p>
                    </th>
                  </tr>

                  <tr>
                    <Th
                      label="SKU"
                      value="sku"
                      style={{ fontSize: 12 }}
                    />

                    <Th
                      label="Descrição"
                      value="descricao"
                      style={{ fontSize: 12 }}
                    />

                    <Th
                      label="Preço Venda"
                      value="precovenda"
                      style={{ fontSize: 12 }}
                    />

                    {localStorage.admin === 'SIM' && (
                      <Th
                        label="Preço Custo"
                        value="precocusto"
                        style={{ fontSize: 12 }}
                      />
                    )}

                    <Th
                      label="Quantidade do Kit"
                      value="quantidade"
                      style={{ fontSize: 12 }}
                    />

                    <Th
                      label="Estoque"
                      value="estoque"
                      style={{ fontSize: 12 }}
                    />

                    <th style={{ fontSize: 12 }}>Ações</th>
                  </tr>
                </>
              </thead>

              <tbody>
                {filteredItems.map((item) => (
                  <tr key={item.codproduto}>
                    <td style={{ fontSize: 12 }}>{item.sku}</td>
                    <td style={{ fontSize: 12 }}>{item.descricao}</td>
                    <td style={{ fontSize: 12 }}>
                      {formatPrice(item.precovenda)}
                    </td>

                    {localStorage.admin === 'SIM' && (
                      <td style={{ fontSize: 12 }}>
                        {formatPrice(item.precocusto)}
                      </td>
                    )}

                    <td style={{ fontSize: 12 }}>{item.quantidade}</td>

                    <td style={{ fontSize: 12 }}>{item.estoque}</td>

                    <td>
                      <Link
                        to={`/produtos/${item.codproduto}`}
                        target="_blank"
                      >
                        <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                          <CustomButton color="#f54927">
                            <PencilFill fontSize={12} />
                          </CustomButton>
                        </OverlayTrigger>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <Paginate />
          </>
        )}
      </Modal.Body>
    </Modal>
  )
}
